interface PaginationProps {
  info: { total_page: number } | null;
  currentPage: number;
  handlePageChange: (page: number) => void;
}

export const RenderPaginationButtons: React.FC<PaginationProps> = ({ info, currentPage, handlePageChange }) => {
  const totalPage = info?.total_page || 1;
  const pages = [];

  // Always show the "Previous" button
  pages.push(
    <button
      key="prev"
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className="btn border rounded-end-0 text-secondary me-1 mt-2"
    >
      Previous
    </button>
  );

  // Show the first 2 pages
  for (let i = 1; i <= Math.min(2, totalPage); i++) {
    pages.push(
      <button
        key={i}
        onClick={() => handlePageChange(i)}
        className={`btn border rounded-0 me-1 mt-2 ${currentPage === i ? 'btn-primary' : 'btn-outline-secondary'}`}
      >
        {i}
      </button>
    );
  }

  // Add ellipsis if necessary before the current range
  if (currentPage > 2 && totalPage > 4) {
    pages.push(<span key="ellipsis-before" className="me-1">...</span>);
  }

  // Show up to 3 pages around the current page (but not exceeding the first two and last two)
  for (let i = Math.max(3, currentPage - 1); i <= Math.min(currentPage + 1, totalPage - 2); i++) {
    pages.push(
      <button
        key={i}
        onClick={() => handlePageChange(i)}
        className={`btn border rounded-0 me-1 mt-2 ${currentPage === i ? 'btn-primary' : 'btn-outline-secondary'}`}
      >
        {i}
      </button>
    );
  }

  // Add ellipsis if necessary after the current range
  if (currentPage < totalPage - 1 && totalPage > 4) {
    pages.push(<span key="ellipsis-after" className="me-1">...</span>);
  }

  // Show the last 2 pages
  for (let i = Math.max(totalPage - 1, 3); i <= totalPage; i++) {
    pages.push(
      <button
        key={i}
        onClick={() => handlePageChange(i)}
        className={`btn border rounded-0 me-1 mt-2 ${currentPage === i ? 'btn-primary' : 'btn-outline-secondary'}`}
      >
        {i}
      </button>
    );
  }

  // Always show the "Next" button
  pages.push(
    <button
      key="next"
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalPage}
      className="btn border rounded-start-0 text-secondary mt-2"
    >
      Next
    </button>
  );

  return <>{pages}</>;
};
